export const WA_LINK =
  "https://wa.me/923365549155?text=Hello%2C%20I%20came%20from%20the%20website.%20I%20want%20to%20buy%20cement";
export const PHONE_DISPLAY = "0336-5549155";
export const PHONE_TEL = "tel:+923365549155";
export const EMAIL = "ghauri707@gmail.com";

export const WHY_SHADES = ["bg-espresso", "bg-[#252219]", "bg-[#33302A]"];

export const BRAND_LOGOS = {
  lucky: "/assets/lucky-logo.png",
  bestway: "/assets/bestway-logo.png",
};

export const PRODUCTS = [
  {
    key: "lucky",
    reportUrl: "/assets/lucky-supreme-lab.pdf",
    reportImg: "/assets/lucky-lab.jpg",
    stats: [
      { value: 60.2, decimals: 2, unit: "MPa" },
      { value: 37.5, decimals: 2, unit: "MPa" },
      { value: 344, decimals: 0, unit: "m²/kg" },
    ],
  },
  {
    key: "bestway",
    reportUrl: "/assets/bestway-lab.jpg",
    reportImg: "/assets/bestway-lab.jpg",
    stats: [
      { value: 53.8, decimals: 2, unit: "MPa" },
      { value: 35.4, decimals: 2, unit: "MPa" },
      { value: 318, decimals: 0, unit: "m²/kg" },
    ],
  },
];

export const LAB_ROWS = [
  { reqNum: 27, lucky: "37.50 MPa", luckyNum: 37.5, bestway: "35.40 MPa", bestwayNum: 35.4 },
  { reqNum: 37, lucky: "47.30 MPa", luckyNum: 47.3, bestway: "44.90 MPa", bestwayNum: 44.9 },
  { reqNum: 53, lucky: "60.20 MPa", luckyNum: 60.2, bestway: "53.80 MPa", bestwayNum: 53.8 },
  { reqNum: 30, lucky: "160 min", luckyNum: 160, bestway: "160 min", bestwayNum: 160 },
  { reqNum: 600, lucky: "215 min", luckyNum: 215, bestway: "220 min", bestwayNum: 220 },
  { reqNum: 229, lucky: "344 m²/kg", luckyNum: 344, bestway: "318 m²/kg", bestwayNum: 318 },
  { reqNum: 10, lucky: "1.0mm", luckyNum: 1.0, bestway: "1.00mm", bestwayNum: 1.0 },
];

export const LAB_REPORTS = ["/assets/lucky-supreme-lab.pdf", "/assets/bestway-lab.jpg"];
